<template>
	<div>
		<div class="container-node-headline">
			<div class="inputs">
				<!-- @vue-expect-error -->
				<div
					v-for="(inputArray, inputName) in dataNode.inputs"
					:class="'input ' + inputName + (inputArray.required ? ' input-required' : '')"
				>
					<div class="hidden-label">
						<!-- @vue-expect-error -->
						{{
							dataNode.data.input_labels
								? dataNode.data.input_labels[inputName] || inputName
								: inputName
						}}
					</div>
				</div>
			</div>
			<span
				class="senaryon-icon senaryon-icon-roles senaryon-icon--with-right-margin"
			></span>
			<span> <!-- @vue-expect-error --> {{ dataNode.data.actor_name }}</span>
			<div class="outputs">
				<!-- @vue-expect-error -->
				<div
					v-for="(outputItem, index) in Object.keys(dataNode.outputs)"
					:class="'output output_' + (index + 1)"
				></div>
			</div>
		</div>
		<!-- @vue-expect-error -->
		<drawflow-top-right-tags
			:tags-to-show="tagsToShow"
			:modal-id="modalId"
			:parent-instance="this"
		></drawflow-top-right-tags>
	</div>
</template>

<script>
import DrawflowHelpers from "./drawflow_helpers";
import DrawflowTopRightTags from "./drawflow_top_right_tags.vue";

export default {
	props: {
		dataNode: Object,
		drawflowInstance: Object,
	},
	components: {
		"drawflow-top-right-tags": DrawflowTopRightTags,
	},
	computed: {
		tagsToShow() {
			return this.drawflowInstance.editor_mode == "edit" ? ["delete"] : [];
		},
	},
	methods: {
		callPositionNode() {
			DrawflowHelpers.positionNode(this);
		},
	},
	mounted() {
		// pp.log("mounted drawflow_actor_item", this.dataNode, this.$el);
		// @ts-expect-error
		this.drawflowHelpers = new DrawflowHelpers(this);
		setTimeout(() => {
			// Move this to the end of the stack so that the $domEl can be appended to `.container-node` in drawflow.js first
			DrawflowHelpers.addToDagre(
				this.drawflowInstance,
				this.dataNode,
				this.$el.closest(".container-node"),
			);
		});
		pp.vue.bus.$on("DRAWFLOW-node-moved", (data) => {
			if (data.nodeId == this.dataNode.id) {
				this.drawflowHelpers.redrawConnections();
			}
		});

		pp.vue.bus.$on("DRAWFLOW-graph-changed", this.callPositionNode);
	},
};
</script>
